import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { injectModelInstantiator, TYPES as MODEL_TYPES } from '../../model/interface/bind';
import {
    bindWorkspaceDB,
    injectWorkspaceDB,
    TYPES as DB_TYPES,
    unbindWorkspaceDB,
} from '../interface/bind';
import type { IDBOptions, IWorkspaceDBInstantiator } from '../interface/instantiator';
import migration from '../private/migration';
import instantiator from './instantiator';

function _build(container: IContainer): Readonly<IWorkspaceDBInstantiator> {
    const modelInstantiator = injectModelInstantiator(container);
    const migrators = [...migration.versions];

    return Object.freeze({
        open: (options: IDBOptions) => instantiator(modelInstantiator, migrators, options),
    });
}

export default buildBindable<IWorkspaceDBInstantiator>({
    id: DB_TYPES.IWorkspaceDBInstantiate,
    dependencies: [MODEL_TYPES.IModelInstantiator],
    bind: bindWorkspaceDB,
    remove: unbindWorkspaceDB,
    build: container => Promise.resolve(_build(container)),
    inject: injectWorkspaceDB,
});
